import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HrToolCompareBarComponent} from '../hr-tool-compare-bar/hr-tool-compare-bar.component';

/** Wraps the HR-tools pages (catalog, detail, compare) so the comparison bar is shared across all of
 * them — adding a tool from any page surfaces the footer bar. */
@Component({
  selector: 'app-hr-tools-layout',
  imports: [RouterOutlet, HrToolCompareBarComponent],
  templateUrl: './hr-tools-layout.component.html',
})
export class HrToolsLayoutComponent {}
